







import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, Mutation } from 'vuex-class';

const namespace: string = 'auth';

@Component
export default class MemberInvite extends Vue {
  @Action('memberInvite', { namespace }) c_memberInvite!: any;

  async created() {
    try {
      const emailCode: any = this.$route.params.code;
      await this.c_memberInvite(emailCode);
    } catch (e) {
      console.log(e);
      this.$message.error(e.response.data.error.message);
      await this.$router.replace('/');
    }
  }
}
